import { useScopeParams } from "@/hooks/useScopeParams";
import { PageTemplate } from "@/components/Templates/PageTemplate";

export default function ConcomitantMedications({
  singleSubjectId,
}: {
  singleSubjectId?: string;
}) {
  const { id } = useScopeParams();

  return (
    <PageTemplate
      title="Safety: Concomitant Medications"
      tooltipText="Explore concomitant medication records, create data subsets, and download data."
      type="conmed"
      constants={{
        wikiLink: "/wiki/guides/exploration-safety-concomitant-medications",
        idLink: (subjectId: string) =>
          `/${id}/subjects/overview/${subjectId}/concomitant-medications`,
      }}
      subjectId={singleSubjectId}
    />
  );
}
